/* tslint:disable */
/* eslint-disable */
/**
 * David Master Api
 * db: david-master
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the ResetPasswordResponseDTO interface.
 */
export function instanceOfResetPasswordResponseDTO(value) {
    let isInstance = true;
    return isInstance;
}
export function ResetPasswordResponseDTOFromJSON(json) {
    return ResetPasswordResponseDTOFromJSONTyped(json, false);
}
export function ResetPasswordResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'token': !exists(json, 'token') ? undefined : json['token'],
    };
}
export function ResetPasswordResponseDTOToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'token': value.token,
    };
}
